import { Swiper, SwiperSlide } from 'swiper/react';
import { useEffect, useState } from 'react';
import { apiGifts } from '../../api/apiGifts.api';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';

export function GiftListProfile({ userId }) {
  const axiosPrivate = useAxiosPrivate();
  const [gifts, setGifts] = useState([]);

  useEffect(() => {
    apiGifts.fetchGiftsById(axiosPrivate, undefined, userId).then(res => setGifts(res.filter(g => g.isGifted)));
  }, []);

  if(gifts.length === 0) return null;

  return (
    <>
      <h1 className="font-raleway font-bold mt-6 text-white text-[18px] mb-2">Подарки</h1>
      <div>
        <Swiper modules={[]} spaceBetween={10} slidesPerView={2.2} className="w-full h-[130px]">
          {gifts.map((g) => (
            <SwiperSlide
              key={g._id}
              className="rounded-[16px] flex justify-center items-center bg-[#FFFFFF1A]"
            >
              <img src={g.imageUrl} alt={g.title} className="w-full h-full p-5" />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  );
}
